export default {
  LANGUAGE: {
    NORWEGIAN: 'Norwegian',
    ENGLISH: 'English',
  },
  BACK: 'Back',
  BACK_TO: 'Back to {genreName}',
  CHECK: 'Check',
  EDIT: 'Edit',
  GENRE: '{genre}',
  GENRE_WRITE: 'Write {genre}',
  GENRE_CHECK: 'Check {genre}',
  GENRE_SHARE: 'Share {genre}',
  EDITOR: {
    TOOLBAR: {
      BOLD: 'Bold',
      ITALIC: 'Italic',
      LIST: 'List',
      MEDIA: 'Insert image',
      NORMAL: 'Normal',
      SPEECH_TO_TEXT: 'Speech to text',
      TABLE: 'Insert table',
    },
    TABLE: {
      COLUMNS: {
        LABEL: 'Columns',
        ADD: {
          BEFORE: 'Insert left column',
          AFTER: 'Insert right column',
        },
        REMOVE: 'Remove column',
      },
      ROWS: {
        LABEL: 'Rows',
        ADD: {
          BEFORE: 'Insert top row',
          AFTER: 'Insert bottom row',
        },
        REMOVE: 'Remove row',
      },
      REMOVE: 'Remove table',
    },
  },
  COLLAPSIBLE: {
    CLOSE: 'close',
  },
  CHECKLIST: {
    TITLE: 'Checklist',
  },
  DISPOSITION: {
    TITLE: 'Tools',
    ALT_IMAGE: 'Outline Structure',
    TOOLS: '',
    FILM: 'Video - How to write {genre}',
    EXAMPLE: 'Example of {genre}',
    AUDIO: 'Sound - {name}',
  },
  ERROR: {
    NO_ACCESS_TITLE: 'You don’t have access to this product',
    NO_ACCESS_MESSAGE: 'Contact your teacher or administrator for more information and help.',
  },
  EXAMPLES: {
    TITLE: 'Example of {genre} | Examples of {genre}',
    LINK_NAME: 'examples',
  },
  HOME: 'Home',
  HEADER: {
    TITLE: 'Language and login',
    MAIN_LANGUAGE: 'Main language',
    MAIN_LANGUAGE_SUBTEXT: 'Changes language in navigation and content',
    PORTAL: 'Portal',
    DROPDOWN_TOGGLE: 'Header dropdown toggle',
    LANG_NB: 'Bokmål',
    LANG_NB_SHORT: 'Bokm.',
    LANG_NN: 'Nynorsk',
    LANG_NN_SHORT: 'Nyno.',
    CLOSE: 'Close',
  },
  FOOTER: {
    PRIVACY: 'Privacy Policy',
    CONTACT: 'Contact Us',
    COOKIE: 'Cookies',
  },
  TASK: 'Task',
  PAGINATION: {
    NEXT: 'Next',
    PREV: 'Previous',
  },
  TASKS: {
    TITLE: 'Task | Tasks',
    LINK_NAME: 'tasks',
  },
  LOADER: {
    TITLE: 'Loading ...',
  },
  SHARE_PAGE: {
    TITLE: 'Share',
    DOWNLOAD: {
      PDF: 'Download PDF',
      WORD: 'Download Word',
    },
  },
  ARCHIVE: {
    ZIP_NAME: 'Compressed folder',
    PDF_NAME: 'PDF document',
    WORD_NAME: 'Word document',
    ATTACHMENT_DIR_NAME: 'Attachments',
  },
  LOGIN: 'Log in',
  LOGOUT: 'Log out',
  SHARE: 'Share',
  VIEW_ALL: 'View all',
  WRITE: 'Write',
  WRITE_STORY: {
    TITLE: 'Write {genre}',
    START_NEW: 'Create new',
    CONTINUE: 'Continue',
  },
  WRITE_PAGE: {
    TIPS: 'Tips',
  },
  EXERCISE: {
    DEFAULT_NAME: 'Unnamed document',
    ATTACHMENT_COUNT: 'Attachments:',
  },
  SPEECH_TO_TEXT: {
    HEADER: {
      READ_IN: 'Record: ',
    },
    START_RECORDING: 'Start recording',
    PAUSE_RECORDING: 'Pause',
    LABEL: 'Read your text: ',
    TRANSLATED_LABEL: 'Prepare text: ',
    CONTINUE_RECORDING: 'Continue recording',
    RESET_RECORDING: 'Reset/Restart',
    ERRORS: {
      DEVICE_NOT_FOUND: 'Unable to detect a microphone. Please check your system settings',
      PERMISSION_DENIED: 'Permission to use microphone denied. Please check your browser settings',
      UNEXPECTED: 'Unexpected error occurred. Please try again later',
    },
  },
  TEXT_TO_SPEECH: {
    LISTEN: 'Listen to the text',
    ERROR_NOT_ALLOWED: 'Audio is ready, click play to listen to the recording.',
    SPEED_LABEL: 'Speed',
    SPEED: {
      SLOWLY: 'Slowly',
      QUICKLY: 'Quickly',
    },
  },
  VIDEO: {
    READ_TRANSCRIPTION: 'Read transcription',
    CHAPTERS: 'Chapters',
  },
  VIEW: {
    HOME: {
      DESCRIPTION:
        'This writing tool helps you write texts in different genres. The tool guides you step by step through all parts of writing, and you can save what you write in Word.',
      GENRES_LABEL: 'Choose genre:',
      TITLE: 'Welcome!',
    },
  },
  ATTACHMENTS: {
    TITLE: 'Attachment (Optional)',
    TEXT: 'Attach up to {maxFiles} files.',
    REMOVE: 'Remove',
  },
  MODAL: {
    PRINT_BUTTON: 'Print',
    OVERWRITE_DOCUMENT: {
      TITLE: 'Information',
      TEXT: 'You will now start in a blank document. Previously saved text will be overwritten.',
    },
    UPLOAD: {
      IMAGE: {
        TITLE: 'Upload Image',
        TEXT: 'Only 1 file per upload. (Supported formats are: Jpeg and Png)',
        BUTTON_UPLOAD: 'Upload image',
      },
      ATTACHMENT: {
        TITLE: 'Upload Attachments',
        TEXT: 'Attach up to 10 files. (Maximum size is 5MB per file)',
        BUTTON_UPLOAD: 'Upload one or more files',
      },
      TITLE: 'Upload files',
      TEXT: 'Attach up to {count} file(s). (Supported formats are Jpeg. PDF and Waw).',
      BUTTON_UPLOAD: 'Upload one or more files',
      PROGRESS: 'Uploading, {progress}% complete',
      FILE_ERROR: 'File is over 5MB!',
      FILE_REMOVE: 'Remove',
      SIZE_ERROR: 'You must remove all files larger than 5MB (in orange) in order to save.',
      PORTRAIT_WARN_TITLE: 'UPS!',
      PORTRAIT_WARN_TEXT:
        'The tool does not rotate portrait images from Macs and iPhones. - It is recommended to select images in landscape format to avoid the problem.',
      CANCEL: 'Cancel',
      SAVE: 'Insert',
    },
    EXAMPLE_DETAILS: {
      DISPOSITION: 'Outline',
      DESCRIPTION: 'Click to see highlights in the text',
      HIGHLIGHT: 'Highlights',
    },
    LOGOUT: {
      TITLE: 'Information',
      TEXT: 'You will be logged out from Fagbokforlaget',
    },
    ERROR: {
      TITLE: 'Error occurred',
      TEXT: 'Unexpected error occurred. Please try again later',
    },
  },
  BUTTON: {
    CANCEL: 'Cancel',
    INSERT: 'Insert',
    START_WRITING: 'Ok, start writing',
  },
  DOCUMENT_CONTROL: {
    MANAGE: 'File',
    SAVE_AS: 'Save as',
    SAVE: 'Save',
    RENAME: 'Rename',
    DELETE: 'Delete',
    CLOSE: 'Close',
  },
  ARIA: {
    CLOSE_MODAL: 'close modal',
    UPLOAD: 'upload file',
    REMOVE_FILE: 'remove file',
    SAVE: 'save',
    CANCEL: 'cancel',
    OK: 'ok',
  },
  IMAGE_FIELD: {
    LABEL_NEW: 'Insert image',
    LABEL_UPDATE: 'Update image',
  },

  RENAME_MODAL: {
    TITLE: 'Change Name',
    OK: 'Ok',
    CLOSE: 'Close',
  },

  REMOVE_MODAL: {
    TITLE: 'Remove document',
    MESSAGE: 'Are you sure?',
    DELETE: 'Remove',
    ABORT: 'Cancel',
  },

  SAVE_AS_MODAL: {
    TITLE: 'Save as:',
    OK: 'Ok',
    CLOSE: 'Cancel',
  },

  DOCUMENT_MODAL: {
    TITLE: 'My documents',
    DESCRIPTION: 'Here you will find your saved documents for all genres.',
    EDIT_BTN: 'Edit',
    SAVE_BTN: 'Done',
    FILTER_ALL: 'All',
    EMPTY: 'No exercise found',
    UNDO_DELETE: 'Undo delete',
  },
  AUTO_SYNC: {
    TITLE: {
      SUCCESS: 'Saved automatically',
      ERROR: 'No internet connection',
      DEFAULT: 'Saving',
    },
    SUBTITLE: {
      SUCCESS: '',
      ERROR: 'Will be saved when internet connection is restored',
      DEFAULT: '',
    },
  },

  ALIGN: {
    RIGHT: 'Align right',
    LEFT: 'Align left',
    CENTER: 'Align center',
  },

  ADJUST_IMAGE: {
    LABEL: 'Adjust',
    WIDTH_100: '100% width',
    WIDTH_50: '50% width',
  },

  SEE_ALL: {
    LINK: 'Show all',
    TASKS: 'All tasks',
    EXAMPLES: 'All exercises',
    TITLE: {
      TASKS: 'Tasks',
      EXAMPLES: 'Examples',
    },
  },
  ALERT: {
    OFFLINE: {
      TITLE: 'Note!',
      TEXT: 'Some features do not work without internet connection.',
      FEATURE_TEXT: 'This feature does not work without internet connection.',
    },
  },
  LOGO: {
    ALT: 'Illustration of gray wrench and green pencil',
  },
};
